<script setup>
const flex = [
  'flex flex-wrap',
  'md:flex-row md:justify-center md:items-stretch',
  'flex-col items-stretch',
]

const flow = [
  { icon: 'user-plus', title: '注册账号' },
  { icon: 'users', title: '完善赛队资料' },
  { icon: 'shuffle', title: '完成在线抽签' },
  { icon: 'book-bookmark', title: '下载比赛赛题' },
  { icon: 'typewriter', title: '上传评比文书' },
  { icon: 'square-up', title: '上传比赛文书' },
  { icon: 'circle-nodes', title: '交换比赛文书' },
  { icon: 'ranking-star', title: '在线评比评分' },
]

const withArrow = (index, flowLength) => {
  return index < flowLength - 1
}
</script>

<template lang="pug">
div.my-4.-mx-4.flex.flex-row.flex-wrap
  WebFeature(
    v-for="(item, index) in flow"
    :key="index"
    :index="index + 1"
    :icon="item.icon"
    :arrow="withArrow(index, flow.length)"
  ) {{ item.title }}
</template>
